<template>
  <router-link class="tax-filing-item" :to="`/tax-filing-detail/${taxFilingId}`">
    <div class="title">{{ companyName }}</div>
    <div>申报周期: {{ period }}</div>
    <div>申报月份: {{ month }}</div>
    <div>申报类型: {{ type }}</div>
    <div class="flex">
      <div v-if="showR10" class="flex-item">增值税:<span class="currency">{{ r10 }}</span></div>
      <div v-if="showR20" class="flex-item">附加税:<span class="currency">{{ r20 }}</span></div>
      <div v-if="showR31" class="flex-item">个人所得税:<span class="currency">{{ r31 }}</span></div>
      <div v-if="showR32" class="flex-item">企业所得税:<span class="currency">{{ r32 }}</span></div>
      <div v-if="showR40" class="flex-item">印花税:<span class="currency">{{ r40 }}</span></div>
      <div v-if="showR50" class="flex-item">工会经费:<span class="currency">{{ r50 }}</span></div>
    </div>
  </router-link>
</template>

<script>
  export default {
    name: "TaxFilingItem",
    props: {
      taxFilingId: {
        type: Number,
        required: true
      },
      companyName: {
        type: String,
        required: true
      },
      period: {
        type: String,
        required: true
      },
      month: {
        type: String,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      r10: {
        //增值税
        type: Number,
        default:null
      },
      r20: {
        //附加税
        type: Number,
        default:null
      },
      r31: {
        //个人所得税
        type: Number,
        default:null
      },
      r32: {
        //企业所得税
        type: Number,
        default:null
      },
      r40: {
        //印花税
        type: Number,
        default:null
      },
      r50: {
        //工会经费
        type: Number,
        default:null
      },
      showR10:{type:Boolean,default:true},
      showR20:{type:Boolean,default:true},
      showR31:{type:Boolean,default:true},
      showR32:{type:Boolean,default:true},
      showR40:{type:Boolean,default:true},
      showR50:{type:Boolean,default:true},
    }
  }
</script>

<style scoped>
  .tax-filing-item {
    border-bottom: 1px solid #D8D8D8;
    padding: 10px 14px;
    font-size: 14px;
    color: #9A9A9A;
    line-height: 28px;
    position: relative;
    text-decoration: none;
    display: block;
  }
  .tax-filing-item  .title {
    font-size: 16px;
    font-weight: bold;
    color: #000;
  }
  .tax-filing-item  .currency {
    color: #FD493A;
  }
  .tax-filing-item .flex{
    display: flex;
    flex-wrap: wrap;
  }
  .tax-filing-item .flex .flex-item{
    flex: 0 0 auto;
    width:50%;
  }
</style>